<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'New' }} Physician Review</h2>
        <hr>

        <form @submit.prevent="submitForm">
            <label>Review Note</label>
            <textarea v-model="form.review_note" class="form-control"></textarea>

            <label>Reviewed At</label>
            <input type="date" v-model="form.reviewed_at" class="form-control">

            <label>Physician</label>
            <select v-model="form.physician_id" class="form-control">
                <option v-for="p in physicians" :value="p.id" :key="p.id">
                    {{ p.user?.name }}
                </option>
            </select>

            <div class="mt-3">
                <button class="btn btn-sm btn-primary" type="submit">
                    {{ isEditing ? 'Update' : 'Create' }}
                </button>

                <button class="btn btn-sm btn-secondary ms-2" type="button" @click="cancel">
                    Cancel
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isEditing: false,
            form: {
                phase_determination_id: this.$route.params.phase_determination_id || '',
                review_note: '',
                reviewed_at: this.getTodayDate(),
                physician_id: '',
            },
            physicians: [],
            student_id: '', // for redirect purpose
        };
    },
    mounted() {
        // this.loadPhysicians();

        if (this.$route.name === 'PhysicianReviewEdit') {
            this.isEditing = true;
            this.loadData();
        } else {
            this.loadPhaseDetermination();
        }
    },
    methods: {
        getTodayDate() {
            return new Date().toISOString().slice(0, 10);
        },

        // async loadPhysicians() {
        //     // const res = await this.$api.get('/physicians');

        //     // this.physicians = res.data;
        // },

        async loadData() {
            const res = await this.$api.get(`/physician-reviews/${this.$route.params.id}`);
            this.form = {
                ...res.data,
                reviewed_at: res.data.reviewed_at?.split(' ')[0] || this.getTodayDate(),
            };
            this.student_id = res.data.phase_determination?.student_id;
        },

        async loadPhaseDetermination() {
            const res = await this.$api.get(`/phase-determinations/${this.$route.params.phase_determination_id}`);
            this.student_id = res.data.student_id;
        },

        cancel() {
            this.$router.push({
                name: 'PhaseDeterminationDetail',
                params: { student_id: this.student_id }
            });
        },

        async submitForm() {
            try {
                if (this.isEditing) {
                    await this.$api.put(`/physician-reviews/${this.$route.params.id}`, this.form);
                } else {
                    await this.$api.post('/physician-reviews', this.form);
                }

                this.$router.push({
                    name: 'PhaseDeterminationDetail',
                    params: { student_id: this.student_id }
                });

            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>